






























































































































































































































import { dataToGetTwilioToken } from '@/modules/Config/Channels/shared/domain/ChannelsController'
import KeybeIcon from '../../icons/KeybeIcon.vue'
import AnimatedAudioBars from '../AnimatedAudioBars/AnimatedAudioBars.vue'
import { KeybeIconType } from '@/shared/infrastructure/enums/icons/KeybeIconType'
import ChannelsUseCases from '@/modules/Config/Channels/shared/application/ChannelsUseCases'
import ChannelsController from '@/modules/Config/Channels/shared/infrastructure/controllers/Channels.controller'
import { mapState } from 'vuex'
import { Contact } from '@/modules/CDP/shared/contacts/domain/Contact'
import { Device } from '@twilio/voice-sdk'
import EmitToast from '@/utils/EmitToast'
export default {
  components: {
    KeybeIcon,
    AnimatedAudioBars
  },
  props: {
    contact: {
      type: Object,
      required: true
    },
    selectedCallLine: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapState('UserStore', ['token', 'user']),
    ...mapState('AppStore', ['selectedApp']),
    ...mapState('ConversationStore', ['selectedRoom']),
    contactComputed (): Contact {
      return this.contact
    },
    contactPhoto (): string {
      if (this.contactComputed?.photo) {
        return this.contactComputed.photo || ''
      }
      return ''
    },
    callerPhoto (): string {
      if (this.user?.photo) {
        return this.user.photo || ''
      }
      return ''
    },
    contactName (): string {
      if (this.contactComputed?.name && this.contactComputed?.surname) {
        return `${this.contactComputed.name} ${this.contactComputed.surname}`
      } else if (this.contactComputed?.name) {
        return this.contactComputed.name
      }
      return ''
    },
    contactPhone (): string {
      if (this.contactComputed?.phone && this.contactComputed?.phone?.length > 0) {
        const firstPhone = this.contactComputed.phone[0]
        return firstPhone.value || ''
      }
      return ''
    }
  },
  data () {
    return {
      KeybeIconType,
      channelsController: new ChannelsController(),
      callStatus: '',
      callDuration: '',
      callTimer: null,
      callerAudio: null,
      userAudioCheckInterval: null,
      userAnalyser: null,
      audioContext: null,
      analyser: null,
      dataArray: null,
      dataArrayUser: null,
      isUserTalking: false,
      isCallerTalking: false,
      microphone: true,
      twilioToken: '',
      twilioDevice: null,
      twilioCall: null,
      twilioRemoteStream: null,
      minimize: false
    }
  },
  async mounted () {
    this.callStatus = ''
    await this.getMicrophonePermissions()
    await this.getTwilioToken()
    await this.setTwilioDevice()
    await this.startCall()
  },
  methods: {
    async getMicrophonePermissions () {
      this.status = 'requestingPermissions_call'
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.microphone = true
        this.detectCallerAudio()
      } catch (err) {
        EmitToast.emitErrors(this.$t('noMicrophonePermissions'))
        this.microphone = false
        this.status = 'permissionsRejected_call'
      }
    },
    async getTwilioToken (): Promise<void> {
      this.status = 'getting_twilio_token'
      const data: dataToGetTwilioToken = {
        token: this.token,
        appUUID: this.selectedApp?.uuid || ''
      }
      const response = await ChannelsUseCases.getTwilioToken(this.channelsController, data)
      if (response.status) {
        this.twilioToken = response.token
      }
    },
    async setTwilioDevice () {
      if (!this.twilioToken) {
        await this.getTwilioToken()
      }
      this.twilioDevice = new Device(this.twilioToken, {
        logLevel: 1 // LogLevel.DEBUG
      })

      this.twilioDevice.on('ready', () => {
        console.log('Twilio Device Ready')
      })

      this.twilioDevice.on('error', (error) => {
        console.error('Twilio Device Error:', error)
      })
    },
    toggleMicrophone () {
      this.microphone = !this.microphone
      if (this.stream && this.stream.getAudioTracks().length > 0) {
        this.stream.getAudioTracks().forEach(track => {
          track.enabled = this.microphone
        })
      }
    },
    hangUpCall () {
      if (this.twilioCall) {
        this.twilioCall.disconnect()
        this.callStatus = 'terminated_call'
        this.stopCallTimer()
      } else {
        this.callStatus = 'disconnected_call'
        this.stopCallTimer()
        this.twilioCall = null
      }
    },
    async startCall () {
      this.callStatus = 'connecting_call'
      if (!this.twilioToken) {
        await this.getTwilioToken()
      }
      if (!this.twilioDevice) {
        await this.setTwilioDevice()
      }
      this.twilioCall = await this.twilioDevice.connect({
        params: {
          To: this.contactPhone,
          Caller: this.selectedCallLine?.phoneNumber || '',
          contactUUID: this.contactComputed?.uuid || ''
        }
      })

      if (!this.twilioCall) {
        console.error('Failed to establish call: No call object returned')
        return
      }

      this.callStatus = this.twilioCall.status()

      this.twilioCall.on('trackAdded', (track) => {
        if (track.kind === 'audio') {
          const audioEl = document.getElementById('remoteAudio')
          if (audioEl) {
            // @ts-ignore
            const stream = audioEl.srcObject || new MediaStream()
            stream.addTrack(track)
            // @ts-ignore
            audioEl.srcObject = stream
            // @ts-ignore
            audioEl.autoplay = true
            // @ts-ignore
            audioEl.play().catch(err => console.warn('Autoplay blocked:', err))
          }
        }
      })

      this.twilioCall.on('accept', () => {
        this.callStatus = 'accepted_call'
        this.startCallTimer()
      })

      this.twilioCall.on('disconnect', () => {
        this.callStatus = 'disconnected_call'
        const audioEl = document.getElementById('remoteAudio')
        // @ts-ignore
        if (audioEl) audioEl.srcObject = null
      })

      this.twilioCall.on('error', (error) => {
        this.callStatus = 'disconnected_call'
        EmitToast.emitErrors(error)
      })

      this.twilioCall.on('reject', () => {
        this.callStatus = 'rejected_call'
      })

      this.twilioCall.on('cancel', () => {
        this.callStatus = 'disconnected_call'
      })

      this.twilioCall.on('ringing', () => {
        this.callStatus = 'ringing_call'
      })
    },
    startCallTimer () {
      this.callDuration = '00:00'
      if (this.callTimer) {
        clearInterval(this.callTimer)
        this.callTimer = null
      }
      this.callTimer = setInterval(() => {
        const [minutes, seconds] = this.callDuration.split(':').map(Number)
        const totalSeconds = minutes * 60 + seconds + 1
        this.callDuration = `${String(Math.floor(totalSeconds / 60)).padStart(2, '0')}:${String(totalSeconds % 60).padStart(2, '0')}`
      }, 1000)
    },
    stopCallTimer () {
      if (this.callTimer) {
        clearInterval(this.callTimer)
        this.callTimer = null
      }
    },
    detectUserAudio () {
      // reset state & clear previous resources
      this.isUserTalking = false

      if (this.userAudioCheckInterval) {
        clearInterval(this.userAudioCheckInterval)
        this.userAudioCheckInterval = null
      }
      if (this.userAnalyser) {
        try { this.userAnalyser.disconnect() } catch (e) {}
        this.userAnalyser = null
      }
      this.dataArrayUser = null

      if (!this.peerConnection) return

      const receivers = this.peerConnection.getReceivers()
      if (!receivers || receivers.length === 0) return

      for (const receiver of receivers) {
        const track = receiver.track
        if (!track || track.kind !== 'audio') continue

        try {
          if (!this.audioContext) {
          // @ts-ignore
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
          }

          // Create media stream from incoming track
          const incomingStream = new MediaStream([track])
          const source = this.audioContext.createMediaStreamSource(incomingStream)

          // create analyser
          this.userAnalyser = this.audioContext.createAnalyser()
          this.userAnalyser.fftSize = 2048
          source.connect(this.userAnalyser)

          // reuse existing dataArrayUser if size matches, otherwise recreate
          const bufSize = this.userAnalyser.fftSize
          if (!this.dataArrayUser || this.dataArrayUser.length !== bufSize) {
            this.dataArrayUser = new Uint8Array(bufSize)
          }

          const threshold = 0.02 // adjust sensitivity as needed
          this.isUserTalking = false

          // polling interval to check RMS of incoming audio
          this.userAudioCheckInterval = setInterval(() => {
            if (!this.userAnalyser || !this.dataArrayUser) {
              this.isUserTalking = false
              return
            }
            try {
              this.userAnalyser.getByteTimeDomainData(this.dataArrayUser)
              let sum = 0
              for (let i = 0; i < this.dataArrayUser.length; i++) {
                const v = (this.dataArrayUser[i] - 128) / 128
                sum += v * v
              }
              const rms = Math.sqrt(sum / this.dataArrayUser.length)
              this.isUserTalking = rms > threshold
            } catch (err) {
              console.warn('user audio check error:', err)
              this.isUserTalking = false
            }
          }, 250)

          // attach to first audio receiver only
          break
        } catch (err) {
          console.warn('detectUserAudio error:', err)
          this.isUserTalking = false
        }
      }
    },
    detectCallerAudio () {
      if (this.stream && this.stream.getAudioTracks().length > 0) {
        this.callerAudio = this.stream.getAudioTracks()[0]
        try {
          if (!this.audioContext) {
          // @ts-ignore
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
          }
          // clean previous analyser if any
          if (this.analyser) {
            try { this.analyser.disconnect() } catch (e) {}
            this.analyser = null
          }
          const source = this.audioContext.createMediaStreamSource(this.stream)
          this.analyser = this.audioContext.createAnalyser()
          this.analyser.fftSize = 2048
          source.connect(this.analyser)
          this.dataArray = new Uint8Array(this.analyser.fftSize)
          const threshold = 0.02 // adjust sensitivity as needed

          // clear previous interval if present
          if (this.audioCheckInterval) {
            clearInterval(this.audioCheckInterval)
            this.audioCheckInterval = null
          }

          // periodically check audio level and set isCallerTalking to true/false
          this.isCallerTalking = false
          this.audioCheckInterval = setInterval(() => {
            if (!this.analyser || !this.dataArray) {
              this.isCallerTalking = false
              return
            }
            this.analyser.getByteTimeDomainData(this.dataArray)
            let sum = 0
            for (let i = 0; i < this.dataArray.length; i++) {
              const v = (this.dataArray[i] - 128) / 128 // normalize -1..1
              sum += v * v
            }
            const rms = Math.sqrt(sum / this.dataArray.length)
            this.isCallerTalking = rms > threshold
          }, 250)
        } catch (err) {
          console.warn('detectCallerAudio error:', err)
          this.isCallerTalking = false
        }
      } else {
        this.callerAudio = null
        this.isCallerTalking = false
        if (this.audioCheckInterval) {
          clearInterval(this.audioCheckInterval)
          this.audioCheckInterval = null
        }
        if (this.analyser) {
          try { this.analyser.disconnect() } catch (e) {}
          this.analyser = null
        }
      }
    }
  }
}
